import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbModalRef} from './../../components/modal/modal-ref';
import {timeOutModalContents} from './../../config/config/config.constants';

interface Content {
  title: string;
  body: any;
  primaryAction: string;
  secondaryAction?: string;
}

@Component({
  selector: 'app-cvs-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimeoutComponent implements OnInit {

  @Input() content: Content;
  @Input() warning: boolean;
  @Input() signedout: boolean;
  public modal: NgbModalRef;

  constructor() {
  }

  ngOnInit() {
    this.content = this.warning ? timeOutModalContents.IDLE_TIME : timeOutModalContents.TIMED_OUT;
    this.content = this.signedout ? timeOutModalContents.SIGNED_OUT : this.content;
  }

  onKeydownLastHandler($event) {
  }

  dismiss(reason?) {
    this.modal.dismiss(reason);
  }

  success() {
    this.modal.dismiss();
  }

}
